var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20px",
        height: "20px",
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#f6c26f",
      },
    },
    [
      _c("g", { attrs: { id: "SVGRepo_bgCarrier", "stroke-width": "0" } }),
      _vm._v(" "),
      _c("g", {
        attrs: {
          id: "SVGRepo_tracerCarrier",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { id: "SVGRepo_iconCarrier" } }, [
        _c("title", [_vm._v("eye-open")]),
        _vm._v(" "),
        _c("g", { attrs: { id: "Layer_2", "data-name": "Layer 2" } }, [
          _c(
            "g",
            { attrs: { id: "invisible_box", "data-name": "invisible box" } },
            [_c("rect", { attrs: { width: "48", height: "48", fill: "none" } })]
          ),
          _vm._v(" "),
          _c("g", { attrs: { id: "icons_Q2", "data-name": "icons Q2" } }, [
            _c("path", {
              attrs: {
                d: "M45.3,22.1h0C43.2,19.5,35.4,11,24,11S4.8,19.5,2.7,22.1a3,3,0,0,0,0,3.8C4.8,28.5,12.6,37,24,37s19.2-8.5,21.3-11.1A3,3,0,0,0,45.3,22.1ZM24,33c-8.8,0-15.3-6.2-17.7-9,2.4-2.8,8.9-9,17.7-9s15.3,6.2,17.7,9C39.3,26.8,32.8,33,24,33Z",
              },
            }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "24", cy: "24", r: "6" } }),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }